import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const MyUploads = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'my-uploads' */
  './MyUploads'
))

export function AsyncMyUploads(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading My Uploads..." />}>
      <MyUploads {...props} />
    </Suspense>
  )
}

export default AsyncMyUploads
